// Get the current date
const today = new Date();
// Calculate tomorrow's date
const tomorrow = new Date(today);
tomorrow.setDate(today.getDate() + 1);
// Calculate the date 12-15 days after tomorrow
const endDate = new Date(tomorrow);
endDate.setDate(tomorrow.getDate() + 15); // Changed from 4 to 15
// Format the dates (e.g., Wed, Jan 15)
const options = { weekday: "short", month: "short", day: "numeric" };
const formattedStartDate = tomorrow.toLocaleDateString("en-US", options);
const formattedEndDate = endDate.toLocaleDateString("en-US", options);
// Estimated delivery time
const estimatedDelivery = "Estimated delivery time: 12-15 days"; // Updated text
// Display the dates in the HTML
document.getElementById("start-date").textContent = formattedStartDate;
document.getElementById("end-date").textContent = formattedEndDate;
document.getElementById("estimated-delivery").textContent = estimatedDelivery;